
export default {
  addDataHeader (orgSet, condSet) {
    let condHeader = "";
    if (orgSet && condSet) {
      for (var i = 0; i < orgSet.header.length; i++) {
        var header = orgSet.header[i];
        if(i>0) condHeader += ",";
        condHeader += header;
      }

      condSet.SetDataHeader(condHeader);
      // console.log('condHeader:'+condHeader);
      for (var j = 0; j < orgSet.data.length; j ++) {
        condSet.AddRow();
        Object.keys(orgSet.data[j]).forEach(k => {
          // if (searchVm.data.hasOwnProperty(k) && searchVm.data[k]) {
          if (orgSet.data[j].hasOwnProperty(k)) {
            // console.log(k+':'+orgSet.data[j][k]);
            condSet.NameString(j+1, k, orgSet.data[j][k]);
          }
        });
        console.log('-------------------');
      }
    }
    return condSet;
  },

  deleteString (str, delchar) {
    var temp = '';
    for (var i = 0; i < str.length; i++) {
        if (str.charAt(i) == delchar) {
            continue;
        } else {
            temp += str.charAt(i);
        }
    }
    return	temp;
  }
};
